import React from "react";
import { FormActions } from "../app";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import {
  QuotationEntityFields,
  QuotationHistoricalOptions,
  QuotationItemsEditor,
  QuotationNotesFields,
  QuotationTermsFields,
} from "./QuotationFormSections";

export function QuotationEditForm({
  editingQuotation,
  formData,
  setFormData,
  clients,
  projects,
  getEntityId,
  formatClientDisplay,
  getTodayDateInput,
  t,
  statusLabels,
  canEditContent,
  formatMoney,
  onSubmit,
  onCancel,
  onAddItem,
  onUpdateItem,
  onRemoveItem,
  onItbmsChange,
}) {
  return (
    <>
      {editingQuotation && !canEditContent && (
        <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 text-sm text-amber-400">
          Esta cotización está en estado{" "}
          <strong>{statusLabels[editingQuotation.status]}</strong>. Solo puedes
          modificar el estado, las notas visibles y las notas internas.
        </div>
      )}

      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">Estado</Label>
          <Select
            value={formData.status}
            onValueChange={(value) => setFormData({ ...formData, status: value })}
          >
            <SelectTrigger className="valhalla-input">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="border-[#242E42] bg-[#151B26]">
              <SelectItem value="borrador">{t("statusDraft")}</SelectItem>
              <SelectItem value="enviada">{t("statusSent")}</SelectItem>
              <SelectItem value="aceptada">{t("statusAccepted")}</SelectItem>
              <SelectItem value="rechazada">{t("statusRejected")}</SelectItem>
              <SelectItem value="vencida">{t("statusExpired")}</SelectItem>
              <SelectItem value="facturada">{t("statusInvoiced")}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <fieldset
          disabled={!canEditContent}
          className={!canEditContent ? "pointer-events-none opacity-60" : ""}
        >
          <div className="space-y-4">
            <QuotationEntityFields
              formData={formData}
              setFormData={setFormData}
              clients={clients}
              projects={projects}
              getEntityId={getEntityId}
              formatClientDisplay={formatClientDisplay}
              t={t}
              disabled={!canEditContent}
            />

            <QuotationHistoricalOptions
              formData={formData}
              setFormData={setFormData}
              getTodayDateInput={getTodayDateInput}
              mode="edit"
              fallbackQuotationNumber={editingQuotation?.quotation_number}
              fallbackIssueDate={editingQuotation?.issue_date}
              disabled={!canEditContent}
            />

            <QuotationItemsEditor
              formData={formData}
              t={t}
              formatMoney={formatMoney}
              onAddItem={onAddItem}
              onUpdateItem={onUpdateItem}
              onRemoveItem={onRemoveItem}
              onItbmsChange={onItbmsChange}
              disabled={!canEditContent}
            />

            <QuotationTermsFields
              formData={formData}
              setFormData={setFormData}
              t={t}
              disabled={!canEditContent}
            />
          </div>
        </fieldset>

        <QuotationNotesFields formData={formData} setFormData={setFormData} t={t} />

        <FormActions
          cancelLabel={t("cancel")}
          submitLabel={t("saveChanges")}
          onCancel={onCancel}
        />
      </form>
    </>
  );
}

export default QuotationEditForm;
